import React from 'react'

import classNames from 'classnames'
import { Link } from 'react-router-dom'

interface Props {
  label: string
  icon?: React.ReactNode
  selected?: boolean
  to: string
  rightContent?: React.ReactNode
  className?: string
}

const MenuItem: React.FC<Props> = ({ label, icon, selected, to, rightContent, className }) => {
  return (
    <Link
      to={to}
      title={label}
      className={classNames(
        'flex flex-row items-center px-2 py-2 sm:py-1.5 w-full rounded h-[32px]',
        selected
          ? 'bg-gray-tabs dark:bg-gray-tabs-dm'
          : 'hover:bg-gray-tabs dark:hover:bg-gray-tabs-dm hover:bg-opacity-20',
        className
      )}
      target="_self">
      {icon && <span className="w-[20px] flex flex-col items-center mr-2.5">{icon}</span>}
      <span className="text-base ellipsify flex-1 text-left">{label}</span>
      {rightContent && <span>{rightContent}</span>}
    </Link>
  )
}

export default MenuItem
